/**
 * I recapiti dell'assistenza, cioe come si raggiunge chi ha costruito il programma.
 *
 * Stanno in banca dati e non nel codice per una ragione sola: un numero di telefono che
 * cambia non deve costringere a ripubblicare l'applicazione. La console li scrive, l'app
 * li legge, e il valore di partenza qui sotto serve solo alla prima accensione.
 */
export const CHIAVE_EMAIL_SUPPORTO = "support.email";
export const CHIAVE_TELEFONO_SUPPORTO = "support.telefono";

export const RECAPITI_DI_PARTENZA: Record<string, string> = {
  [CHIAVE_EMAIL_SUPPORTO]: "support.manutio@cristianbedin.it",
  // Vuoto di proposito: il numero lo scrive Cristian dalla console, e finche non c'e
  // la schermata non mostra un pulsante "chiama" che non chiama nessuno.
  [CHIAVE_TELEFONO_SUPPORTO]: "",
};

export type RecapitiSupporto = {
  email: string;
  telefono: string;
};

/** Un numero come si scrive dentro un collegamento `tel:`: senza spazi, il resto com'e. */
export function numeroPerChiamata(telefono: string) {
  return telefono.replace(/\s/g, "");
}
